import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//action import
import { fetchMoreServices, pushServiceRequest, resolveEnquiry, deleteEnquiry } from "../../../actions/ServicesActions";

//common imports
import {Spinner} from "../../common/Spinner";
import moment from "moment";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {message, Popconfirm, Popover, Button} from "antd";
import FilterEnquires from "./FilterEnquires";

class NewEnquires extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            services: this.props.services,
            servicesLoading: this.props.servicesLoading,
            moreServicesLoading: this.props.moreServicesLoading,
            startAt: this.props.startAt,
            enquiryFilter: this.props.enquiryFilter,
        };

        this.onMoreServicesPress = this.onMoreServicesPress.bind(this);
        this.onResolveEnquiry = this.onResolveEnquiry.bind(this);
        this.onDeleteEnquiry = this.onDeleteEnquiry.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps !== this.props) {
            this.setState({
                services: nextProps.services,
                servicesLoading: nextProps.servicesLoading,
                moreServicesLoading: nextProps.moreServicesLoading,
                startAt: nextProps.startAt,
                enquiryFilter: nextProps.enquiryFilter,
            })
        }
    }

    onMoreServicesPress() {
        const { startAt } = this.state;

        //add startAt number
        const addedStartAt = startAt + 20;

        this.props.fetchMoreServices({ startAt: addedStartAt });

    }

    onDeleteEnquiry(service) {
        this.props.deleteEnquiry({service});
    }

    onResolveEnquiry(service) {
        this.props.resolveEnquiry({service});
    }

    onDeletionCancel() {
        message.info("Deletion is canceled").then();
    }

    onResolvedCancel() {
        message.info("Resolution is canceled").then();
    }

    renderMoreButton() {
        const { moreServicesLoading } = this.state;

        if (moreServicesLoading) {
            return <Spinner/>
        } else {
            return (
                <div className={"newCustomerButtonBox"}>
                    <Button type={"primary"} onClick={() => this.onMoreServicesPress()}>More</Button>
                </div>
            );
        }
    }

    renderServices() {
        const { services, servicesLoading, enquiryFilter } = this.state;

        if(servicesLoading) {
            return <Spinner/>
        } else {
            if (services.length !== 0) {
                let filteredEnquiries = [];
                const newEnquiries= services.filter(service => service.resolve === false);

                switch (enquiryFilter) {
                    case "nssf123":
                        filteredEnquiries = newEnquiries.filter(service => service.serviceCategory.legalServiceID === "nssf123");
                        break;
                    case "tax123":
                        filteredEnquiries = newEnquiries.filter(service => service.serviceCategory.legalServiceID === "tax123");
                        break;
                    default:
                        filteredEnquiries = newEnquiries.map(service => service);
                }

                return (
                    <div>
                        <FilterEnquires/>
                        {
                            filteredEnquiries.map(service => {
                                let seconds;
                                service.serviceRequestDate.seconds ? seconds =  service.serviceRequestDate.seconds : seconds =  service.serviceRequestDate._seconds;
                                const dateObj = moment.unix(seconds);
                                const dateString = dateObj.format("Do MMM YYYY | HH:mm");

                                const enquiryNote = (
                                    <div>
                                        <p>{service.serviceNote}</p>
                                    </div>
                                );

                                const enquireContacts = (
                                    <div>
                                        <p>{service.email}</p>
                                        <p>{service.phone}</p>
                                        <p>{service.companyName}</p>
                                    </div>
                                );

                                return (
                                    <div key={service.serviceRequestID} className={"boxCard"}>
                                        <div className={"announcementBox"}>
                                            <div>
                                                <h2>{service.serviceCategory.legalServiceTitle}</h2>
                                                <p>{service.name}</p>
                                                <div>
                                                    <Popover content={enquiryNote} title="Title" style={{ marginRight: '0.5rem'}}>
                                                        <Button type="primary" style={{ marginRight: '0.5rem'}}>View Note</Button>
                                                    </Popover>
                                                    <Popover content={enquireContacts} title="Title" style={{ marginRight: '0.5rem'}}>
                                                        <Button type="primary" style={{ marginRight: '0.5rem'}}>View Contact</Button>
                                                    </Popover>
                                                </div>
                                                <p style={{ marginTop: "1rem" }}>{dateString}</p>
                                            </div>

                                            <Popconfirm
                                                title="Resolve this enquiry?"
                                                onConfirm={() => this.onResolveEnquiry(service)}
                                                onCancel={() => this.onResolvedCancel()}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <div className={"clickable"} style={{textAlign: 'center', justifyContent: "center", alignItems: "center", backgroundColor: "green"}}><FontAwesomeIcon icon={"check"} color={"#ffffff"} size={"1x"} className={"trashIcon2"}/></div>
                                            </Popconfirm>
                                            <Popconfirm
                                                title="Are you sure to delete this enquiry?"
                                                onConfirm={() => this.onDeleteEnquiry(service)}
                                                onCancel={() => this.onDeletionCancel()}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <div className={"clickable"} style={{textAlign: 'center', justifyContent: "center", alignItems: "center", backgroundColor: "#D7373B"}}><FontAwesomeIcon icon={"trash"} color={"#ffffff"} size={"1x"} className={"trashIcon2"}/></div>
                                            </Popconfirm>
                                        </div>
                                    </div>
                                );
                            })
                        }

                        { this.renderMoreButton() }
                    </div>
                );
            } else {
                return <h3 style={{ fontFamily: "myriadBold", fontSize: 20 }}>No services enquired yet</h3>
            }
        }
    }

    render() {
        return(
            <div>
                { this.renderServices() }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { services, servicesLoading, moreServicesLoading, startAt, enquiryFilter } = state.services;

    return {
        services,
        servicesLoading,
        moreServicesLoading,
        startAt,
        enquiryFilter
    }
}

export default withRouter(connect(mapStateToProps, { fetchMoreServices, pushActivity: pushServiceRequest, resolveEnquiry, deleteEnquiry })(NewEnquires));